import { ReactElement } from "react";
import { catcat as cc } from "cerulean";
import { Row } from "@narmi/design_system";
import styles from "../PaymentActivity.module.scss";

const DrawerRow = ({
  row,
  index,
  totalRows,
}: {
  row: [string, string | undefined | ReactElement<any>];
  index: number;
  totalRows: number;
}) => {
  const [heading, content] = row;

  return content ? (
    <div
      key={`row-${heading}__${index}`}
      className={cc({ "margin--bottom--l": index !== totalRows - 1 })}
    >
      <Row>
        <Row.Item shrink>
          <p className="fontColor--secondary">{heading}</p>
        </Row.Item>
        <Row.Item>
          <div className={styles.rowContent}>
            <span className={styles.ellipsisWrapperRightAligned}>
              {content}
            </span>
          </div>
        </Row.Item>
      </Row>
    </div>
  ) : null;
};

export default DrawerRow;
